import PropTypes from 'prop-types'

export default {
  contextTypes: {
    errors: PropTypes.func,
    setFormValue: PropTypes.func
  }
}
